/*@flow*/
import type { Node } from 'react';
import React, { Fragment } from 'react';
import Alert from './Alert';
import Fieldset from './Fieldset';
import { SectionBefore, SectionAfter } from './Sections';
import type { LocalsT, StructLocals } from '../types';

type PropsT = LocalsT & StructLocals;

type Registry = {|
  Fieldset: React$StatelessFunctionalComponent<*>,
|};

const StructItem = ({ element }) => element || null;

const clone = (overrides: $Shape<Registry> = {}) => {
  let registry = {};

  function Struct(locals: PropsT) {
    return (
      <Fragment>
        <registry.SectionBefore {...locals} />
        <registry.Fieldset {...locals}>
          {locals.help && <Alert type="info" message={locals.help} />}
          {locals.error && locals.hasError && (
            <Alert type="danger" message={locals.error} />
          )}
          {locals.order.map((name, i) => (
            <StructItem element={locals.inputs[name]} key={i * 10} />
          ))}
        </registry.Fieldset>
        <registry.SectionAfter {...locals} />
      </Fragment>
    );
  }

  Struct.clone = clone;

  registry = {
    Fieldset,
    SectionBefore,
    SectionAfter,
    ...overrides,
  };

  return Struct;
};

declare class CloneableClass {
  (locals: PropsT): Node;
  clone(overrides?: $Shape<Registry>): CloneableClass;
}

export default (clone(): CloneableClass);
